import { RouteRecordRaw } from 'vue-router';
import { Role } from '@/router/enum';

export const androidAppRoute: RouteRecordRaw = {
  path: 'android',
  name: 'android',
  meta: {
    title: '安卓应用',
    key: 'android',
    icon: 'android-outlined',
    permission: [Role.ADMIN, Role.USER, Role.ANDROID_ADMIN],
  },
  children: [
    {
      path: 'android-publish',
      name: 'android-publish',
      component: () =>
        import('@/views/back-stage-management/Android/index.vue'),
      meta: {
        title: '发布',
        key: 'android-publish',
        icon: 'cloud-upload-outlined',
        permission: [Role.ADMIN, Role.USER, Role.ANDROID_ADMIN],
      },
    },
    {
      path: 'android-project',
      name: 'android-project',
      component: () =>
        import('@/views/back-stage-management/Android/page/project.vue'),
      meta: {
        title: '项目列表',
        key: 'android-project',
        icon: 'ProfileOutlined',
        permission: [Role.ADMIN, Role.ANDROID_ADMIN],
      },
    },
  ],
};
